module.exports = __webpack_public_path__ + "img/SOKAL-SRS-121021-Aviator-Established.bbae0f86.jpeg";